import { APP_ENV } from '@/env';

export const BILLING_KEY_DOMAIN = {
  production: 'https://payments.realworld.to',
  development: 'https://payments-test.realworld.to',
  staging: 'https://payments-staging.realworld.to'
}[APP_ENV];

export const PRO_PERIOD_MAP: Record<string, string> = {
  monthly: 'ProMonthsPlan',
  yearly: 'ProYearPlan'
};
